export default function getResource(label) {
    const resources = {
        inStorePickup: 'In-Store Pickup',
        curbsidePickup: 'Curbside Pickup',
        beautyServices: 'Beauty Services',
        storeEvents: 'Store Events',
        freeSamples: 'Free Product Sampling'
    };

    return resources[label];
}
